import styled from "styled-components";
import { ionGradientText } from "../../styles/ionGradientText";
import { revealStyle } from "../../styles/scrollReveal";

export const SectionTitle = styled.h2<{ $visible: boolean }>`
  align-self: stretch;
  text-align: center;
  white-space: pre-line;

  font-family: Pretendard;
  font-size: clamp(35px, 7vw, 42px);

  font-weight: 700;
  line-height: 130%;

  padding: 0 24px;
  margin-bottom: 36px;

  ${ionGradientText}
  ${revealStyle}
`;
